import { Container, Row, Col, Table, Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const MeasurementCategoriesTable = ({ categories, loading, onAddNewCategory, onEdit, onDelete }) => {
	if (loading) {
		return (
			<div className="text-center my-5">
				<Spinner animation="border" role="status">
					<span className="visually-hidden">Loading categories...</span>
				</Spinner>
			</div>
		);
  	}

	return (
		<Container fluid className="py-4">
			<Row>
				<Col md={12} className="text-md-end">
					<Button
						variant="primary"
						onClick={onAddNewCategory}
						className="mt-4"
					>
						<FontAwesomeIcon icon={faPlus} className="me-2" />
						Add New
					</Button>
				</Col>
			</Row>

			<h2 className="mb-4 fs-2">Measurement Types</h2>

			<Table  striped bordered hover responsive className="mb-0">
				<thead className="table-striped">
					<tr>
						<th>#</th>
						<th>Type Name</th>
						<th>Description</th>
						<th>Created</th>
						<th>Updated</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{categories && categories.length > 0 ? (
						categories.map((cat, index) => (
							<tr key={cat.id}>
								<td>{index + 1}</td>
								<td>{cat.type_name}</td>
								<td>{cat.measurement_description}</td>
								<td>
									{new Date(cat.created_at).toLocaleDateString()}
									<br />
									<small className="text-muted">
										{new Date(cat.created_at).toLocaleTimeString()}
									</small>
								</td>
								<td>
									{cat.updated_at ? (
										<>
										{new Date(cat.updated_at).toLocaleDateString()}
										<br />
										<small className="text-muted">
											{new Date(cat.updated_at).toLocaleTimeString()}
										</small>
										</>
									) : (
										<span className="text-muted">-</span>
									)}
								</td>
								<td align="center">
									<div className="d-flex gap-2 justify-content-center">
											<Button
												variant="warning"
												size="sm"
												title="Edit"
												onClick={() => onEdit(cat)}
												className="d-flex align-items-center p-2 gap-2">
												<FontAwesomeIcon icon={faEdit} />
											</Button>
											<Button
												variant="danger"
												size="sm"
												title="Delete"
												onClick={() => {
													if (window.confirm( "Are you sure you want to delete this category?")) { onDelete(cat.id)}
												}}
												className="d-flex align-items-center p-2 gap-2">
												<FontAwesomeIcon icon={faTrash} />
											</Button>
									</div>
								</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan="6" className="text-center text-muted py-4"> No measurement categories added yet. </td>
						</tr>
					)}
				</tbody>
			</Table>

			<div className="d-flex justify-content-end mt-3 me-3">
				<span className="text-muted"> Showing {categories?.length || 0} records </span>
			</div>
		</Container>
	);
};

export default MeasurementCategoriesTable;